<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasMove" 
         aria-labelledby="offcanvasMoveLabel"
      >
      <!--
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasMoveLabel">Mover a...</h6>
         <button 
            id="bttCloseOcMoveTo"
            type="button" 
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_out_offcanvas"
            ></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body gap-0">
         <div v-for="(cell, index) in cells" :key="index" class="form-check">
            <input class="form-check-input" 
               type="radio" 
               :id="cell.id" 
               :value="cell.id" 
               v-model="movePicked"
               :disabled="!cell.canCardsInOut"
                />
            <label v-if="cell.canCardsInOut" :for="cell.id">{{cell.name}}</label>
            <label v-else :for="cell.id" class="text-decoration-line-through">{{cell.name}}</label>
         </div>
            <div class="d-grid py-2">
            <button v-if="movePicked != cellId"  class="btn btn-primary" :disabled="moving" @click="moveTo(movePicked)"> <!-- :disabled="sorting || !newSort" @click="doSort()" > -->
               <span v-show="moving" class="spinner-border spinner-border-sm"></span>
               {{txtBttMove}}
            </button>
         </div>
         <!-- v-show="sorting"
         <div v-if="movePicked != cellId" class="row px-1 pt-2">
            <div class="fp-onOff btn-info rounded" @click="moveTo(movePicked)">
               Mover
            </div>
         </div>
         -->
      </div>
         <!-- @click="setColorId(0)"
         -->
   </div>
   </div>
</template>

<script>
//import { ref, nextTick, watchEffect } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const boardId = ref(null)
      const btn_out_offcanvas = ref(null)
      const cellId = ref(0)
      const cellContentId = ref(0)
      const cells = ref([])
      const movePicked = ref('')
      const moving = ref(false)
      const txtBttMove = ref('')

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasMove')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            cellContentId.value = button.getAttribute('data-cellContent-id')
         moving.value = false
         txtBttMove.value = 'Mover'
         boardId.value = WspService.getBoardId(store)
         getCellsByBoard()
         movePicked.value = cellId.value
         myOffCanvas.focus()
         console.log(" show move's OC")
         })
         console.log("move's OC")
      })

      function userAppModule() {
         let uAppIndex = store.state.auth.userAppIndex;
         if (uAppIndex) {
            let uAppModule = store.state.auth.userAppModule;
            return uAppModule.appModuleComponent[uAppIndex];
         }
         return 0;
      }

      function getCellsByBoard() {
         WspService.getCellsByBoard(boardId.value)
         .then(response => {
            //console.log(response.data)
            cells.value = response.data
            //console.log("colors ok: "+colors.value)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function focusOff() {
         //
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            //console.log(timer)
            if (movePicked.value == cellId.value)
               btn_out_offcanvas.value.click()
            //console.log(timer)
         }             
         }, 125)
         //
         //         this.$refs.btnEdit.click(); btn-out-offcanvas
         //console.log("sali del offCanvas")
      }

      function moveTo(cellIdToAdd) {
         //console.log('remove: '+cellContentId.value+', '+cellId.value+', 0, null, ID, desc')
         changePosition(cellContentId.value, cellId.value, 0, null)
         let indexRemove = cells.value.findIndex((obj => obj.id == cellId.value))
         //console.log('add: '+cellContentId.value+', '+cellIdToAdd+', null, 0, ID, desc')
         changePosition(cellContentId.value, cellIdToAdd, null, 0)
         let indexAdd = cells.value.findIndex((obj => obj.id === cellIdToAdd))
         //console.log(cells.value[indexRemove].name+' a '+cells.value[indexAdd].name)
         //
         moving.value = true
         txtBttMove.value = 'Moviendo'
         //
         WspService.addAuditContent(
               cnttId.value, 
               "RMV", 
               store.state.auth.user.id, 
               cells.value[indexRemove].name+' a '+cells.value[indexAdd].name,
               cellId.value,
               null,
               boardId.value
               )
         .then(response => {
            store.dispatch("wspace/setContentId", -8)
            console.log(response);
         })
         .catch(error => {
            console.log(error);
         });
         /*
         setTimeout(() => {
            store.dispatch("wspace/setContentId", -8)
         }, 1000) // 6000)
         */
      }

      function changePosition(cellContentId, cellId, oldIndex, newIndex) {
         WspService.changePosition(cellContentId, cellId, oldIndex, newIndex, 'ID', 'desc')
         .then(response => {
            console.log(response);
         })
         .catch(error => {
            console.log(error);
         });
      }

      return {
         btn_out_offcanvas,
         focusOff,
         cellId,
         cells,
         cnttId,
         movePicked,
         moveTo,
         moving,
         txtBttMove,
         userAppModule,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 50px;
  right: 5%;
  width: 350px;
  height: fit-content;
}
/*
  right: 100px;
*/
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
</style>